// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__2gwgi","linkSm":"Link_linkSm__20syF"};